(function (app) {
    app.provider("stickyNoteDndService", [function () {
        this.$get = [function () {
            var service = {};
            var beginListeners = [];
            var endListeners = [];
            var completeListeners = [];

            service.beginDrag = function () {
                beginListeners.forEach(function (listener) { listener(); });
            };

            service.endDrag = function () {
                endListeners.forEach(function (listener) { listener(); });
            };

            service.completeNote = function() {
                completeListeners.forEach(function (listener) { listener(); });
            }

            service.onBeginDrag = function (callbackFn) {
                beginListeners.push(callbackFn);

                return function () {
                    var index = beginListeners.indexOf(callbackFn);
                    beginListeners.splice(index, 1);
                };
            };

            service.onEndDrag = function (callbackFn) {
                endListeners.push(callbackFn);

                return function () {
                    var index = endListeners.indexOf(callbackFn);
                    endListeners.splice(index, 1);
                };
            };

            service.onComplete = function(callbackFn) {
                completeListeners.push(callbackFn);

                return function() {
                    var index = completeListeners.indexOf(callbackFn);
                    completeListeners.splice(index, 1);
                }
            }

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line